module.exports = __webpack_public_path__ + "static/img/2017-06-10 13.37.43.6014670.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cabins/main/2017-06-10 13.37.43.jpg
// module id = XgLy
// module chunks = 4